module.exports = __webpack_public_path__ + "static/img/sh30q.8113fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/sh30q.png
// module id = RqqI
// module chunks = 37